export default {"src":"/_next/static/media/oca.ed081e87.svg","height":9,"width":62,"blurWidth":0,"blurHeight":0};